

import * as Yup from "yup";

import {
  Button,
  Card,
  Col,
  Dropdown,
  InputGroup,
  Row,
} from "@themesberg/react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  getAllDataOfDispenserSrNo,
  getDataScannedOrNot,
  getFieldIssueDetailsGetData,
  postFieldIssue,
  postFieldIssuecloseworkorder,
  postGetotpDetailsFieljob
} from "../../Service/AllServicesAPI";
import { deleteOtp, fetchOtp } from "../../Service/AllProductionAPI"
import {
  getCustomerList,
  getDealerList,
  getServiceEngineerList,
} from "../master/AllUserDropDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faBackward, faClipboard, faStepBackward } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import NotScanned from "../NotScanned";
import Select from "react-select";
import Swal from "sweetalert2";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import moment from "moment-timezone";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import Toast from 'react-bootstrap/Toast';

export default (props) => {
  const [show, setShow] = useState(false);
  const [csd, setCsd] = useState([1]);
  const [mre, setMre] = useState([1]);
  const [lkd, setLkd] = useState([1]);

  // newly added board vr and printer
  const [pvr, setPvr] = useState([1]);
  const [prn, setPrn] = useState([1]);

  const location = useLocation();
  const [workOrder, setWorkOrder] = useState("");
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [processData, setProcessData] = useState([]);
  const [dispenserSrNo, setDispenserSrNo] = useState("");
  const [selected, setSelected] = useState("");
  let type = null;
  const [oprationType, setOprationType] = useState("");
  const [subOprationType, setSubOprationType] = useState("");
  const [dealerMblNo, setDealerMblNo] = useState("");
  const [serviceEngineerNm, setServiceEngineerNm] = useState("");
  const [userMblNo, setUserMblNo] = useState("");
  const [siteType, setSiteType] = useState("");
  const [siteNm, setSiteNm] = useState("");
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [customerNm, setCustomerNm] = useState("");
  const [dealerName, setDealerName] = useState([]);
  const [customerName, setCustomerName] = useState([]);
  const [customerMblNo, setCustomerMblNo] = useState("");
  const [dealerNm, setDealerNm] = useState("");
  const [serviceEngineerId, setServiceEngineerId] = useState("");
  const [dealerId, setDealerId] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [curreLocation, setCurreLocation] = useState({});
  const [isLoaded, setisLoaded] = useState(false);
  const [prodT, setProdT] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64Image, setBase64Image] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [filedDispenserphoto, SetfiledDispenserphoto] = useState('');
  const [arkNo, setArkNo] = useState("");
  const [volumeTotalizer, setVolumeTotalizer] = useState("");
  const [jobNo, setJobNo] = useState("");
  const [newBoardScerialNo, setnewBoardScerialNo] = useState("");
  const [siteAddress, setSiteAddress] = useState("")
  const [selectedJobType, setSelectedJobType] = useState("OTP");
  const [Desc, setDesc] = useState("");
  const [showToast, setShowToast] = useState(true);
  const [otpData, setOtpData] = useState(null);
  // loading text in button 
  const [loadingbutton, setLoadingbutton] = useState(false);
  // toggle of otp and close field job form fields
  const [isVerifyEnabled, setVerifyEnabled] = useState(true);
  const [isOtpEnabled, setOtpEnabled] = useState(true);

  // disable and enable get otp button after 1 minutues
  const [isOtpdisable, setOtpdisable] = useState(true);

  // close field job button disable
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // image validation to keep button disable
  const [iscalibrationstartcloseEnables, setButtonDisabled] = useState(true);

  // button name change based on operation type
  const [buttonText, setButtonText] = useState('Get OTP');

  const [modelName, setModelName] = useState('');

  const [closeComp, SetCloseComp] = useState(true);

  const [pkFieldotpId, setpkFieldotpId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [arkError, setArkError] = useState("");

  const [selectedIssue,SetSelectedIssue]=useState('');

  const [roManagerName,setroManagerName]=useState("");
  const [roManagerEmail,setroManagerEmail]=useState("");
  const [roManagerMobNo,setroManagerMobNo]=useState("");
  const [fkRoManagerId,setfkRoManagerId]= useState("");

  const [otpType,setOtpType]= useState('');

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute, second] = time24.split(":");
    const parsedHour = parseInt(hour, 10);
    const period = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
    return `${formattedHour}:${minute}:${second} ${period}`;
  };

  const displayFormattedTime = selectedTime
    ? formatTimeTo12Hour(selectedTime)
    : "";

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  // useEffect(() => {
  //   fetchOtpFromApi();
  // }, []);

  // useEffect(() => {
  //   if (!(oprationType === "Time Change" || oprationType === "Date Changes")) {
  //     setSelectedJobType("otp");
  //     setButtonText('Get OTP');
  //   } else {
  //     setSelectedJobType('nonotp'); // Reset or set a default if needed
  //     setButtonText('Send Data');
  //   }
  // }, [oprationType]);

    useEffect(() => {
    if (otpType==="OTP") {
      setSelectedJobType("otp");
      setButtonText('Get OTP');
    } else {
      setSelectedJobType('nonotp'); // Reset or set a default if needed
      setButtonText('Send Data');
    }
  }, [oprationType]);

  const getPassedData = () => {
    if (location.state && location.state.data) {
      sessionStorage.setItem("getFieldDispenserData", JSON.stringify(location.state.data));
      return location.state.data;
    }
    const saved = sessionStorage.getItem("getFieldDispenserData");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  useEffect(() => {
    getCustomersList();
    getServiceEngineersList();
    getDealersList();

    geolocation();
    if (role === "service engineer") {
      const data = getPassedData();
      if (data) {
        console.log("GetDispenser data :-", data);
        setWorkOrder(data.workOrderSerialNo);
        setDispenserSrNo(data.generateUniqueDispenserNo);
        // getDataScanOrNot(data.generateUniqueDispenserNo);
        getAllDataOfDispenSrNo(data.generateUniqueDispenserNo);
        setCustomerNm(data.customerName); //siteType
        setCustomerMblNo(data.customerMobNo);
        setServiceEngineerNm(data.serviceEngineerName);
        setServiceEngineerId(data.fkServiceEngineerId);
        setUserMblNo(data.serviceEngineerMobNo);
        setDealerNm(data.dealerName);
        setDealerMblNo(data.dealerMobNo);
        setSiteType(data.siteType);
        setSiteNm(data.siteLocation);
        setDealerId(data.fkDealerId);
        setCustomerId(data.fkCustomerId);
        setOtpType(data.otpType);
        setOprationType(data.oprationType);
        SetSelectedIssue(data.selectedIssue);
        setSubOprationType(data.subOprationType);
        setroManagerName(data.roManagerName);
        setroManagerEmail(data.roManagerEmail);
        setroManagerMobNo(data.roManagerMobNo);
        setfkRoManagerId(data.fkRoManagerId);
        // setProdT(data.productType);
      }
    }
    // eslint-disable-next-line
  }, []);



  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  // Function declaration of get Service Engineers list
  const getServiceEngineersList = async () => {
    await getServiceEngineerList().then((result) => {
      setServiceEngineerName(result);
    });
  };
  // Function declaration of get Dealer list
  const getDealersList = async () => {
    await getDealerList().then((result) => {
      setDealerName(result);
    });
  };

  const geolocation = () => {
    if (!navigator.geolocation) {
      // swal("Failed", "Geolocation is not supported in your browser", "warning");
      console.log("Geolocation is not supported in your browser");
    } else {
      navigator.geolocation.getCurrentPosition((position) => {
        console.log("Position :-", position);
        const { latitude, longitude } = position.coords;
        console.log("latitude, longitude :-", latitude, longitude);
        setCurreLocation({ latitude, longitude });
      });
    }
  };

  const alertMessage = () => {
    Swal.fire({
      position: "top-center",
      title: "Please scan the device and get the data from dispenser.",
      showConfirmButton: false,
      timer: 3000,
    });
  };

  const selectjob = [
    { value: "otp", label: "OTP" },
    { value: "nonotp", label: "NON OTP" },
  ];



  const getAllDataOfDispenSrNo = (disSrNo) => {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    console.log("dispenserSrNo :-", disSrNo);
    getAllDataOfDispenserSrNo(disSrNo, headers)
      .then((result) => {
        console.log("getAllDataOfDispenSrNo result to check model name :-", result);
        setProdT(result.data.productType);
        setModelName(result.data.modelName);
      })
      .catch((error) => {
        console.log("getAllDataOfDispenSrNo error :-", error);
      });
  };

  const selectOTPtype = [
    { value: "Marry New Hardware", label: "Marry New Hardware" },
    { value: "Marry New Firmware", label: "Marry New Firmware" },
    { value: "Rate Change", label: "Rate Change" },
    { value: "Supervisor Unlock", label: "Supervisor Unlock" },
    { value: "Clear magnet error", label: "Clear magnet error" },
    {
      value: "Reconnect MRE (Pulsar)",
      label: "Reconnect MRE (Pulsar)",
    },
    { value: "To Open ERA Door", label: "To Open ERA Door" },
    { value: "To Close ERA Door", label: "To Close ERA Door" },
    { value: "To Open Hydraulic Door", label: "To Open Hydraulic Door" },
    { value: "To Close Hydraulic Door", label: "To Close Hydraulic Door" },
    {
      value: "To Mandate Pulsar Back To Mapped Nozzle",
      label: "To Mandate Pulsar Back To Mapped Nozzle",
    },
    { value: "Date Change", label: "Date Change" },
    { value: "Time Change", label: "Time Change" },
    // { value: "hangingHardwareChange", label: "Hanging Hardware Change"}
  ];

  //    Allow To Reconnect Of Same MRE (
  // Pulsar
  // )

  const disabledOptions = [6, 7, 8, 9, 10];

  const MarryNewBoard = [
    { value: "ETOT/MEM Board", label: "ETOT/MEM Board" },
    { value: "CSD Board", label: "CSD Board" },
    { value: "LKD Board", label: "LKD Board" },
    { value: "MCU Board", label: "MCU Board" },
    { value: "MRE (Pulsar) Board", label: "MRE (Pulsar) Board" },
  ];

  const MarryNewHardware = [
    { value: "ETOT/MEM Board", label: "ETOT/MEM Board" },
    { value: "CSD Board", label: "CSD Board" },
    { value: "LKD Board", label: "LKD Board" },
    { value: "MCU Board", label: "MCU Board" },
    { value: "MRE (Pulsar) Board", label: "MRE (Pulsar) Board" },
    { value: "PRN Board", label: "PRINTER Board" },
    { value: "PVR Board", label: "VAPOR RECOVERY Board" },
  ];

  const startCalibration = [
    { value: "Nozzle 1", label: " Nozzle 1" },
    { value: "Nozzle 2", label: " Nozzle 2" },
    { value: "Nozzle 3", label: " Nozzle 3" },
    { value: "Nozzle 4", label: " Nozzle 4" },
    { value: "Nozzle 5", label: " Nozzle 5" },
    { value: "Nozzle 6", label: " Nozzle 6" },
    { value: "Nozzle 7", label: " Nozzle 7" },
    { value: "Nozzle 8", label: " Nozzle 8" },
  ];

  const endCalibration = [
    { value: "Nozzle 1", label: " Nozzle 1" },
    { value: "Nozzle 2", label: " Nozzle 2" },
    { value: "Nozzle 3", label: " Nozzle 3" },
    { value: "Nozzle 4", label: " Nozzle 4" },
    { value: "Nozzle 5", label: " Nozzle 5" },
    { value: "Nozzle 6", label: " Nozzle 6" },
    { value: "Nozzle 7", label: " Nozzle 7" },
    { value: "Nozzle 8", label: " Nozzle 8" },
  ];

  const rateChange = [
    { value: "Concerned Product", label: "Concerned Product" },
    // { value: "Nozzle 2", label: "Nozzle 2" },
    // { value: "Nozzle 3", label: "Nozzle 3" },
    // { value: "Nozzle 4", label: "Nozzle 4" },
    // { value: "Nozzle 5", label: "Nozzle 5" },
    // { value: "Nozzle 6", label: "Nozzle 6" },
    // { value: "Nozzle 7", label: "Nozzle 7" },
    // { value: "Nozzle 8", label: "Nozzle 8" },
    // { value: "Product No. 1", label: "Product No 1" },
    // { value: "Product No. 2", label: "Product No 2" },
    // { value: "Product No. 3", label: "Product No 3" },
    // { value: "Product No. 4", label: "Product No 4" },
  ];

  const supervisorUnlock = [
    { value: "Supervisor Unlock", label: "Supervisor Unlock" },
  ];

  const clearmagneterror = [
    { value: "MRE (Pulsar) Board 1", label: "MRE (Pulsar) Board 1" },
    { value: "MRE (Pulsar) Board 2", label: "MRE (Pulsar) Board 2" },
    { value: "MRE (Pulsar) Board 3", label: "MRE (Pulsar) Board 3" },
    { value: "MRE (Pulsar) Board 4", label: "MRE (Pulsar) Board 4" },
    { value: "MRE (Pulsar) Board 5", label: "MRE (Pulsar) Board 5" },
    { value: "MRE (Pulsar) Board 6", label: "MRE (Pulsar) Board 6" },
    { value: "MRE (Pulsar) Board 7", label: "MRE (Pulsar) Board 7" },
    { value: "MRE (Pulsar) Board 8", label: "MRE (Pulsar) Board 8" },
  ];
  const toMandatepulsarbacktomappednozzle = [
    { value: "Nozzle 1", label: "Nozzle 1" },
    { value: "Nozzle 2", label: "Nozzle 2" },
    { value: "Nozzle 3", label: "Nozzle 3" },
    { value: "Nozzle 4", label: "Nozzle 4" },
    { value: "Nozzle 5", label: "Nozzle 5" },
    { value: "Nozzle 6", label: "Nozzle 6" },
    { value: "Nozzle 7", label: "Nozzle 7" },
    { value: "Nozzle 8", label: "Nozzle 8" },
  ];

  const dateChange = [{ value: "Date Change", label: "Date Change" }];

  const timeChange = [{ value: "Time Change", label: "Time Change" }];

  // const hangingHardwareChange = [
  //   { value: "mcuChange", label: "MCU Change" },
  //   { value: "totChange", label: "TOT Change" },
  //   { value: "lkdChange", label: "LKD Change" },
  // ];

  //Conditon for operation Type filter

  if (selected === "Marry New Hardware") {
    type = MarryNewHardware;
  } else if (selected === "Marry New Firmware") {
    type = MarryNewBoard;
  } else if (selected === "Calibration Start") {
    type = startCalibration;
  } else if (selected === "End Calibration") {
    type = endCalibration;
  } else if (selected === "Rate Change") {
    type = rateChange;
  } else if (selected === "Supervisor Unlock") {
    type = supervisorUnlock;
  } else if (selected === "Clear magnet error") {
    type = clearmagneterror;
  } else if (selected === "Reconnect MRE (Pulsar)") {
    type = clearmagneterror;
  } else if (selected === "To Open ERA Door") {
    type = startCalibration;
  } else if (selected === "To Close ERA Door") {
    type = startCalibration;
  } else if (selected === "To Open Hydraulic Door") {
    type = startCalibration;
  } else if (selected === "To Close Hydraulic Door") {
    type = startCalibration;
  } else if (selected === "To Mandate Pulsar Back To Mapped Nozzle") {
    type = toMandatepulsarbacktomappednozzle;
  } else if (selected === "Date Change") {
    type = dateChange;
  } else if (selected === "Time Change") {
    type = timeChange;
    // } else if (selected === "hangingHardwareChange") {
    //   type = hangingHardwareChange;
  }

  // Added new boards in modelQty (prn and pvr)  with other boards (csd,mre,lkd) and (Mcu,Tot)

  const modelQty = [
    {
      modelNo: "1111",
      csd: [1],
      mre: [1],
      lkd: [1],
      prn: [1],
      pvr: [1],
    },
    {
      modelNo: "1121",
      csd: [1, 1],
      mre: [1],
      lkd: [1],
      prn: [1],
      pvr: [1],
    },
    {
      modelNo: "1222",
      csd: [1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2222",
      csd: [1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2422",
      csd: [1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "3622",
      csd: [1, 1],
      mre: [1, 1, 1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "4822",
      csd: [1, 1],
      mre: [1, 1, 1, 1, 1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "1242",
      csd: [1, 1, 1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2242",
      csd: [1, 1, 1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "1444",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2444",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "3644",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "4844",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1, 1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
  ];

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };




  const uploadImg = (e) => {
    console.log("uploadImg :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("file :-", file);

    if (file) {
      // Check if the file is an image
      if (!file.type.startsWith('image/')) {
        // If the file is not an image, set the error message
        SetfiledDispenserphoto("Please upload an image file.");
        setButtonDisabled(true);
        return;
      }

      // Check if the image size exceeds 100 KB
      if (file.size > 100 * 1024) { // 100 KB in bytes
        // If the image size exceeds 100 KB, set the error message
        SetfiledDispenserphoto(
          <p>
            The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
            <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank">
              <span style={{ color: 'blue', textDecoration: 'none' }}>https://image.pi7.org/reduce-image-size-in-kb</span>
            </a>.
          </p>
        );
        setButtonDisabled(true);
        return;
      }

      // If the file is an image and size is within limits, proceed with reading it
      const reader = new FileReader();
      reader.onload = () => {
        setBase64Image(reader.result);
        setButtonDisabled(false);
      };
      reader.readAsDataURL(file);
      setUploadedImage(file);
    }
  };


  // select otp or non otp functionality without using inbuilt formik
  const handleChange = (selectedOption) => {
    setSelectedJobType(selectedOption ? selectedOption.value : '');
  };


         const token = sessionStorage.getItem("token");
          const fkUserId = sessionStorage.getItem("pkUserId");
         const fetchOtpFromApi = async () => {
             if (!fkUserId || !token) {
               console.error("Missing fkUserId or token in sessionStorage.");
               return;
             }
         
             try {
               setLoading(true);
               const fetchedData = await fetchOtp(fkUserId, token);
               console.log("Fetched OTP Data (Navbar):", fetchedData);
         
               if (fetchedData?.otp) {
                 setOtpData(fetchedData);
               } else {
                 setOtpData(null);
                 console.warn("No OTP data found.");
               }
             } catch (error) {
               console.error("Error fetching OTP:", error);
             } finally {
               setLoading(false);
             }
           };


  // This function is used to get OTP and verify ARK on the click of the "Get OTP" button
  const HandleSendOtpFieldjob = async () => {

    setLoadingbutton(true)
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    const payload = {
      workOrderSerialNo: workOrder,
      productType: prodT,
      modelName: modelName,
      generateUniqueDispenserNo: dispenserSrNo,
      arkNo: arkNo,
      oprationType: oprationType,
      subOprationType: subOprationType,
      volumeTotalizer: volumeTotalizer,
      jobNo: jobNo,
      fieldIssueDate: moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
      fieldIssueTime: moment(displayFormattedTime, "hh:mm:ss A").format("hh:mm:ss A"),
      fkDealerId: dealerId,
      customerName: customerNm,
      customerMobileNo: customerMblNo,
      roManagerEmail:roManagerEmail,
      roManagerMobNo:roManagerMobNo,
      roManagerName:roManagerName,
      fkRoManagerId  :fkRoManagerId,
      siteType: siteType,
      dealerName: dealerNm,
      fkCustomerId: customerId,
      selectedIssue:selectedIssue,
      otpType:otpType,
      description: Desc,
      dealerMobileNo: dealerMblNo,
      fkServiceEngineerId: serviceEngineerId,
      serviceEngineerName: serviceEngineerNm,
      serviceEngineerMobNo: userMblNo,
      longitude: curreLocation.longitude,
      latitude: curreLocation.latitude,
      siteName: siteNm,
      jobType: selectedJobType,
      siteAddress: siteAddress,
      newBoardScerialNo:newBoardScerialNo,
    };

    // Disable OTP button immediately
    setOtpdisable(true);

    try {
      // Send the request to get OTP
      const response = await postGetotpDetailsFieljob(payload, headers);

      const { message, status } = response.data;

      if (status === 200) {
        if (message === "First Generate ARK ON Dispenser Then, SCAN.") {
          swal("", message, "info");
        } else if (message === "Scanning Required..") {
          swal("", message, "warning");
        } else if (message === "INVALID Operation Type And SubOperation Type..") {
          swal("", message, "warning");
        } else if (message === "PKI Server is down..") {
          swal("", message, "info");
        } else if (message === "ARK verification Failed") {
          swal("", message, "error");
        } else if (message === "Your Scanning for wrong Dispenser Serial Number..") {
          swal("", "Your Scanning for wrong Dispenser Serial Number...", "error");
        } else if (message === "FieldIssue details added successfully") {
          swal("Great", message, "success");
          setLoadingbutton(false)
          setOtpdisable(false);
          setTimeout(() => {
            setOtpdisable(true);
          }, 60000);
        
                  fetchOtpFromApi()
        } else {
          swal("Error", "Unexpected response message", "error");
        }
      } else {
        swal("Error", "Unexpected status code", "error");
      }
    } catch (error) {
      console.log("Error sending OTP:", error);
      swal("Failed", "Failed", "error");

      // Re-enable OTP button in case of error
      // setOtpdisable(false);
    }
    finally {

      setLoadingbutton(false)
    }
  };




    const handleDeleteOtp = async () => {
      if (!otpData?.pkFieldotpId) {
        console.error("OTP ID not found.");
        return;
      }
    
      try {
        setLoading(true);
        const result = await deleteOtp(otpData.pkFieldotpId);
    
        if (result.success) {
          console.log("OTP deleted successfully.");
          setOtpData(null); // Remove from UI
        } else {
          alert("Failed to delete OTP.");
        }
      } catch (error) {
        console.error("Error deleting OTP:", error);
      } finally {
        setLoading(false);
      }
    };
    



  const Handlesubmitfiledjob = async (values, { resetForm }) => {
    try {

      const pkUserId = sessionStorage.getItem("pkUserId");
      let data = {
        generateUniqueDispenserNo: dispenserSrNo,
        workOrderSerialNo: workOrder,
        remark: values.remark,
        uploadDispenserPhoto: base64Image,

      };
      console.log("GetFieldDispenser check  data of post fild issue :-", data);
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      await postFieldIssuecloseworkorder(data, headers)
        .then((result) => {
          console.log("result of field issue :-", result);
          const message = result.data.message;
          if (message === "ARK verification Failed Here") {
            setisLoaded(false);
            swal("Failed", "ARK verification failed here", "error");
          } else if (message.includes("dispenser data is not scaned for this work order addFieldIssueDetailsX")) {
            swal("Warning", "Dispenser data is not scanned for this work order", "warning");
          } else if (message === "PKI Server is down..here") {
            swal("", "PKI Server is down here", "info");
          } else if (message === "FieldIssue Work Order Not Valid") {
            swal("", "FieldIssue Work Order is Not Valid", "info");
          } else if (message === "FieldIssue Work Order Not Valid") {
            swal("Warning", "FieldIssue Work Order is not valid", "warning");
          } else if (message === "FieldIssue Work Order Closed successfully") {
            swal("Great", "FieldIssue Work Order Closed successfully", "success");
            handleDeleteOtp()
            SetCloseComp(false)
            setIsButtonDisabled(true);
            setTimeout(() => {
              window.location.href = "serviceModule/verification-fieldIssue-list";
            }, 7000);


          }


        })
        .catch((error) => {
          console.log("Field Issue Error :-", error);
          setisLoaded(false);
          if (error.response.status === 404) {
            swal("Failed", `Failed to close field issue `, "warning");

          } else if (error.response.data.status === 500) {
            swal("Failed", `${error.response.data.message}`, "warning");
          }
        });
    } catch (error) {
      console.log(error);
      swal("Failed", "Failed to close field issue", "error");

    }
  }

//    const handleArkChange = (e) => {
//   const value = e.target.value.toUpperCase();


//   if (!/^[A-Z0-9]*$/.test(value)) return;

  
//   if (value.length > 10) return;

//   setArkNo(value);

//   // custom validation
//   if (value.length < 10) {
//     setArkError("ARK No. length must be exactly 10 ");
//   } else {
//     setArkError("");
//   }
// };

  return (
    <Formik
      initialValues={{
        generateUniqueDispenserNo: "",
        workOrderSerialNo: "",
        remark: "",
        uploadDispenserPhoto: "",

      }}
      // validationSchema={validationSchema}
      onSubmit={Handlesubmitfiledjob}


    >
      {(formik) => {
        const { isValid, dirty, isSubmitting, values } = formik;
        // const isGetOtpButtonEnabled = !(oprationType === "Rate Change" || oprationType === "Time Change" || oprationType === "Date Change")
        //   ? arkNo && volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && Desc
        //   : volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && Desc; // arkNo is not required for these operation types



        //   const isGetOtpButtonNewBoard = (oprationType === "Marry New Hardware")
        //   ? arkNo && volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && Desc && newBoardScerialNo
        //   : arkNo && volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && Desc; // arkNo is not required for these operation types


        // const isVerifyButtonEnabled = arkNo;
        // const isgetotpButtonEnabled = volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && Desc;
        const isfieldjobButtonEnabled = jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && values.uploadDispenserPhoto && values.remark && Desc;


//         const noArkOperations = [ "Time Change", "Date Change"];

// const isSendDataEnabled = (() => {
//   const common =
//     jobNo &&
//     startDate &&
//     displayFormattedTime &&
//     selectedJobType &&
//     siteAddress &&
//     Desc;

//   if (oprationType === "Marry New Hardware") {
//     return common && arkNo.length === 6 &&
//   !arkError && newBoardScerialNo;
//   }

//   if (noArkOperations.includes(oprationType)) {
//     return common; 
//   }

//   return common && arkNo.length === 6 &&
//   !arkError && volumeTotalizer; 
// })();




const isSendDataEnabled = (() => {
  const common =
    jobNo &&
    startDate &&
    displayFormattedTime &&
    selectedJobType &&
    siteAddress &&
    Desc;


  // CASE 1: NON-OTP 

  if (otpType === "NON_OTP") {
    return common; // Only common fields required
  }


  // CASE 2: OTP 


  // 2A: Marry New Hardware → special rule
  if (oprationType === "Marry New Hardware") {
    return (
      common &&
      arkNo?.length === 6 &&
      !arkError &&
      newBoardScerialNo &&
      volumeTotalizer
    );
  }

  // 2B: All other OTP operations → normal rule
  return (
    common &&
    arkNo?.length === 6 &&
    !arkError &&
    volumeTotalizer &&
    oprationType &&
    subOprationType
  );
})();

        return (
          <>
            <div className="d-flex mb-2">
              <Link
                to="verification-fieldIssue-list"
                className="fieldLink btn btn-primary"
              >
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" />{" "}
                My Jobs
                <span className="icon icon-small ms-1"></span>
              </Link>

            </div>
            <Card border="light" className="bg-white shadow-sm mb-4">

              <Card.Body>
                {/* {showForm ? ( */}
                <>
                  <h5 className="head mb-4">Submit Field Job</h5>

                  {/* {closeComp ?
                    <OtpFormBased /> : ""} */}


{/* {otpData?.template && showToast ? (
  <Toast
    onClose={() => setShowToast(false)}
    show={showToast}
    delay={1004456646400} 
    autohide
    style={{
      position: 'absolute',
      right: '20px',
      top: '520px',
      marginBottom: '20px',
      zIndex: '10000',
      backgroundColor: '#007bff',
      color: 'white',
    }}
  >
    <Toast.Header>
      <img
        src="holder.js/20x20?text=%20"
        className="rounded me-2"
        alt=""
      />
      <strong className="me-auto text-black">Field Job OTP Notification</strong>
    </Toast.Header>
    <Toast.Body>{otpData.template}</Toast.Body>
  </Toast>
) : null} */}


                  <Form>
                    <Row>
                      {/* <Col md={6}> <Button onClick={handleDeleteClick}>Delete OTP</Button></Col> */}
                     
                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="lable mb-1">
                            {" "}
                            Job Type *{" "}
                          </label>
                          <div className="example-wrapper">
                            
                              <Field
                                type="text"
                                className="form-control"
                         
                                // placeholder="OTP or NON OTP"
                                // value={selectedJobType === 'otp' ? 'OTP' : 'Non OTP'}
                                value={otpType}
                                readOnly
                              />
                      
                          </div>
                          
                        </div>

                      </Col>

                           <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="lable mb-1">
                            {" "}
                           Issue Reported
                          </label>
                          <div className="example-wrapper">
                            
                              <Field
                                type="text"
                                className="form-control"
                               value={selectedIssue}
                                readOnly
                              />
                           
                          </div>
                         
                        </div>

                      </Col>
                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="Label mb-1">
                            {" "}
                            Dispenser Configuration
                          </label>
                          <Field
                            type="text"
                            className="form-control"
                            name="modelName"
                            placeholder="Dispenser Configuration"
                            value={modelName}
                            readOnly
                          />
                        </div>
                      </Col>
                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="Label mb-1">
                            {" "}
                            Work Order No.{" "}
                          </label>
                          <Field
                            type="text"
                            className="form-control"
                            name="workOrderNo"
                            placeholder="Work Order No."
                            value={workOrder}
                            readOnly
                          />
                        </div>
                      </Col>

                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="Label mb-1">
                            {" "}
                            Dispenser Serial No
                          </label>
                          <Field
                            type="text"
                            className="form-control"
                            name="generateUniqueDispenserNo"
                            placeholder="Dispenser Serial No."
                            value={dispenserSrNo}
                            readOnly
                          />
                        </div>

                      </Col>
                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="Label mb-1"> Product Type </label>
                          <Field
                            placeholder="Select Product Type"
                            className="form-control"
                            value={prodT}
                            readOnly
                          />
                        </div>
                      </Col>

                      {/* {!(oprationType === "Time Change" || oprationType === "Date Change") && ( */}
                       
                      {/* )} */}

                      {
                        otpType==="OTP"?
                      

                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="lable mb-1">
                            {" "}
                            Operation Type *{" "}
                          </label>
                          <div className="example-wrapper">
                            <ToolTip
                              content="Select Operation Type"
                              direction="bottom"
                            >
                              {/* <Select
                                  name="oprationType"
                                  title="Select OTP"
                                  placeholder="Select OTP"
                                  options={selectOTPtype}
                                  isOptionDisabled={(option) =>
                                    disabledOptions.includes(
                                      selectOTPtype.indexOf(option)
                                    )
                                  }
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "oprationType",
                                      e.value
                                    );
                                    setSelected(e.value);
                                  }}
                                /> */}
                              <Field
                                name="oprationType"
                                className="form-control"
                                placeholder="Select Operation Type"
                                value={oprationType}
                                readOnly
                              />
                            </ToolTip>
                          </div>
                          {/* <ErrorMessage
                              name="oprationType"
                              component={TextError}
                            /> */}
                        </div>

                      </Col>
      : ""}

      { otpType==="OTP"?
                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="lable mb-1">
                            {" "}
                            Sub Operation Type *{" "}
                          </label>
                          <div className="example-wrapper">
                            <ToolTip
                              content="Select Sub Operation"
                              direction="bottom"
                            >
                              {/* <Select
                                  name="subOprationType"
                                  title=""
                                  placeholder="Select Sub Operation"
                                  options={type}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "subOprationType",
                                      e.value
                                    );
                                  }}
                                /> */}
                              <Field
                                name="subOprationType"
                                className="form-control"
                                placeholder="Select OTP"
                                value={subOprationType}
                                readOnly
                              />
                            </ToolTip>
                          </div>
                          {/* <ErrorMessage
                              name="subOprationType"
                              component={TextError}
                            /> */}
                        </div>
                      </Col>
:""}
                      
                      {/* {isVerifyEnabled && (
                        <> */}
                        
{otpType==="OTP"?
                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">ARK NO *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter ARK no"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  // name="arkNo"
                                  value={arkNo}
                                  placeholder="Enter ARK No."
                                  autoComplete="off"
                                  // onChange={(e) => setArkNo(e.target.value)}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^[A-Z0-9]*$/.test(value) && value.length <= 6) {
                                      setArkNo(value);
                                    }
                                  }}
                                />

                                {/* <Field
                                  type="text"
                                  className="form-control"
                                  value={arkNo}
                                  placeholder="Enter ARK No."
                                  autoComplete="off"
                                  onChange={handleArkChange}
                                /> */}
                              </ToolTip>
                            </div>
                        {/* {arkError && <div className="text-danger mt-1">{arkError}</div>} */}
                          </div>
                        </Col>
                        :""}

                        {
                          otpType==="OTP"?
                        
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="LabelNew mb-1">
                                {" "}
                                Volume Totalizer *{" "}
                              </label>
                              <div className="example-wrapper">
                                <ToolTip
                                  content="Enter Volume Totalizer"
                                  direction="bottom"
                                >
                                  <Field
                                    type="text"
                                    className="form-control"
                                    // name="volumeTotalizer"
                                    value={volumeTotalizer}
                                    // onChange={(e) => setVolumeTotalizer(e.target.value)}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*\.?\d*$/.test(value)) {
                                        setVolumeTotalizer(value);
                                      }
                                    }}
                                    placeholder="Enter Volume Totalizer"
                                    autoComplete="off"
                                  // onInput={(e) => {
                                  //   e.target.value = e.target.value.replace(
                                  //     /[^\d.]+/g,
                                  //     ""
                                  //   );
                                  // }}
                                  />
                                </ToolTip>
                              </div>
                              <ErrorMessage
                                name="volumeTotalizer"
                                component={TextError}
                              />
                            </div>
                          </Col> 
                          :""}

                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="LabelNew mb-1">Job No *</label>
                              <div className="example-wrapper">
                                <ToolTip
                                  content="Enter Job No"
                                  direction="bottom"
                                >
                                  <Field
                                    type="text"
                                    className="form-control"
                                    // name="jobNo"
                                    placeholder="Enter Job No."
                                    autoComplete="off"
                                    value={jobNo}
                                    // onChange={(e) => setJobNo(e.target.value)}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*$/.test(value)) {
                                        setJobNo(value);
                                      }
                                    }}
                                  />
                                </ToolTip>
                              </div>
                              <ErrorMessage name="jobNo" component={TextError} />
                            </div>
                          </Col>
                         {oprationType== "Marry New Hardware" ?
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="LabelNew mb-1">New Board Serial No *</label>
                              <div className="example-wrapper">
                                <ToolTip
                                  content="Enter New Board Serial Number"
                                  direction="bottom"
                                >
                                  <Field
                                    type="text"
                                    className="form-control"
                              
                                    placeholder="Enter New Board Serial Number"
                                    autoComplete="off"
                                    value={newBoardScerialNo}
                                    onChange={(e) => setnewBoardScerialNo(e.target.value)}
                                  />
                                </ToolTip>
                              </div>
                              <ErrorMessage name="newBoardScerialNo" component={TextError} />
                            </div>
                          </Col>
                          :""}
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="LabelNew mb-1">
                                {" "}
                                Field Job Date *{" "}
                              </label>
                              <br />
                              <div className="example-wrapper">
                                <ToolTip content="Select Date" direction="bottom">
                                  <DatePicker
                                    showIcon
                                    closeOnScroll={true}
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    className="form-control"
                                    dateFormat="dd-MMM-yyyy"
                                    placeholderText="Select Date"
                                  />
                                </ToolTip>
                              </div>
                              {/* <ErrorMessage name="fieldIssueDate" component={TextError} /> */}
                            </div>
                          </Col>
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="LabelNew mb-1">
                                {" "}
                                Field Job Time *{" "}
                              </label>
                              <br />
                              <div className="time-wrapper">
                                <div className="allTime">
                                  <input
                                    type="time"
                                    onChange={handleTimeChange}
                                    className="form-control"
                                    step="1"
                                  />
                                </div>
                                <div className="addTime">
                                  <div className="example-wrapper">
                                    <ToolTip
                                      content="Please Select Time "
                                      direction="bottom"
                                    >
                                      <Field
                                        className="form-control"
                                        name="fieldIssueTime"
                                        placeholder="Please Select Time"
                                        value={displayFormattedTime}
                                        readOnly
                                      />
                                    </ToolTip>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1">
                                {" "}
                                Service Engineer Name
                              </label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Service Engineer Name"
                                readOnly
                                value={serviceEngineerNm}
                              />
                            </div>
                          </Col>
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1">
                                {" "}
                                Service Engineer Mobile No
                              </label>
                              <Field
                                type="text"
                                maxLength="10"
                                className="form-control"
                                name="serviceEngineerMobNo"
                                value={userMblNo}
                                placeholder="Mobile No."
                                readOnly
                              />
                            </div>
                          </Col>
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1"> Site Type</label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Select Site Type"
                                readOnly
                                value={siteType}
                              />
                            </div>
                          </Col>
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1"> Site Name</label>
                              <Field
                                type="text"
                                className="form-control"
                                name="siteName"
                                placeholder="Site Name"
                                readOnly
                                value={siteNm}
                              />
                            </div>
                          </Col>

                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="Label mb-1"> RO Manager Name</label>
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="ro Manager Name"
                            readOnly
                            value={roManagerName}
                          />
                        </div>
                      </Col>

                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="Label mb-1"> Ro Manager Email</label>
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="Ro Manager Email"
                            readOnly
                            value={roManagerEmail}
                          />
                        </div>
                      </Col>

                      <Col md={6} className="mb-3">
                        <div className="form-group">
                          <label className="Label mb-1">Ro Manager Mobile Number</label>
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="Ro Manager Mobile"
                            readOnly
                            value={roManagerMobNo}
                          />
                        </div>
                      </Col>
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1"> Customer Name</label>
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Customer Name"
                                readOnly
                                value={customerNm}
                              />
                            </div>
                          </Col>
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="Label mb-1">
                                {" "}
                                Customer Mobile No *{" "}
                              </label>
                              <Field
                                type="text"
                                maxLength="10"
                                name="customerMobileNo"
                                value={customerMblNo}
                                className="form-control"
                                placeholder="Customer Mobile No"
                                readOnly
                              />
                            </div>
                          </Col>
                          {!(siteType === "COCO") && (
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">Dealer Name</label>
                                <Field
                                  type="text"
                                  className="form-control"
                                  placeholder="Dealer Name"
                                  value={dealerNm}
                                  readOnly
                                />
                              </div>
                            </Col>
                          )}
                          {!(siteType === "COCO") && (
                            <Col md={6} className="mb-3">
                              <div className="form-group">
                                <label className="Label mb-1">
                                  {" "}
                                  Dealer Mobile No{" "}
                                </label>
                                <Field
                                  type="text"
                                  maxLength="10"
                                  id="dealerMobileNo"
                                  name="dealerMobileNo"
                                  value={dealerMblNo}
                                  className="form-control"
                                  placeholder="Dealer Mobile No"
                                  readOnly
                                />
                              </div>
                            </Col>
                          )}
                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="LabelNew mb-1">
                                {" "}
                                Site Location Update *{" "}
                              </label>
                              <div className="example-wrapper">
                                <ToolTip
                                  content="Enter Site location"
                                  direction="bottom"
                                >
                                  <Field
                                    type="text"
                                    className="form-control"
                                    // name="siteAddress"
                                    placeholder="Enter Site Location"
                                    autoComplete="off"
                                    value={siteAddress}
                                    onChange={(e) => setSiteAddress(e.target.value)}
                                  />
                                </ToolTip>
                              </div>
                              <ErrorMessage
                                name="siteAddress"
                                component={TextError}
                              />
                            </div>
                          </Col>


                          <Col md={6} className="mb-3">
                            <div className="form-group">
                              <label className="LabelNew mb-1">
                                Description *
                              </label>
                              <div className="example-wrapper">
                                <ToolTip
                                  content="Enter Suitable Description"
                                  direction="bottom"
                                >
                                  <Field
                                    as="textarea"
                                    rows="3"
                                    maxLength={100}
                                    className="form-control"
                                    // name="desc"
                                    value={Desc}
                                    placeholder="Enter Description"
                                    autoComplete="off"
                                    onChange={(e) => setDesc(e.target.value)}
                                  />
                                </ToolTip>
                              </div>
                              <ErrorMessage name="desc" component={TextError} />
                            </div>
                          </Col>
                          <div className="form-group mt-1">

                            {/* <button
                              type="button"
                              className="btn btn-info mb-3 flex-grow-1"
                              onClick={HandleSendOtpFieldjob}
                              disabled={!isgetotpButtonEnabled || !isOtpdisable || !isGetOtpButtonEnabled ||!isGetOtpButtonNewBoard}
                            >
                              {loadingbutton ? (
                                <span className="ms-2">Please wait..</span>
                              ) : (
                                buttonText
                              )}

                            </button> */}

                            <button
  type="button"
  className="btn btn-info mb-3"
  onClick={HandleSendOtpFieldjob}
  disabled={!isSendDataEnabled || !isOtpdisable}
>
  {loadingbutton ? "Please wait..." : buttonText}
</button>


                          </div>

                        {/* </>
                      )} */}
                      {isOtpEnabled && (
                        <>
                          <Col md={6} className="mt-2">
                            <div className="form-group">
                              <label className="LabelNew mb-1">
                                {" "}
                                Upload Dispenser Photo *{" "}
                              </label>
                              <div className="example-wrapper">
                                <ToolTip
                                  content="Upload dispenser photo"
                                  direction="bottom"
                                >
                                  <input
                                    type="file"
                                    className="form-control"
                                    name="uploadDispenserPhoto"
                                    placeholder="Upload Dispenser Photo"
                                    accept=".jpg, .jpeg, .png"
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        "uploadDispenserPhoto",
                                        e.currentTarget.files[0]
                                      );
                                      SetfiledDispenserphoto('')
                                      uploadImg(e);
                                    }}
                                  />
                                </ToolTip>
                              </div>
                              {/* <ErrorMessage
                              name="uploadDispenserPhoto"
                              component={TextError}
                            /> */}
                              {filedDispenserphoto && <p className="text-danger">{filedDispenserphoto}</p>}
                            </div>
                          </Col>
                          <Col md={6} className="mt-2 mb-3">
                            <div className="form-group">
                              <label className="LabelNew mb-1">
                                {" "}
                                Field Engineer Remark *{" "}
                              </label>
                              <div className="example-wrapper">
                                <ToolTip
                                  content="Enter Remark"
                                  direction="bottom"
                                >
                                  <Field
                                    as="textarea"
                                    className="form-control "
                                    rows="3"
                                    placeholder="Remark"
                                    name="remark"
                                  />
                                </ToolTip>
                              </div>
                              <ErrorMessage name="remark" component={TextError} />
                            </div>
                          </Col>
                          <Col >
                            <button
                              type="submit"
                              className="btn btn-primary mb-5"
                              disabled={!isfieldjobButtonEnabled || iscalibrationstartcloseEnables || isButtonDisabled}
                            >
                              Submit Field Job{" "}
                            </button>
                          </Col>
                        </>
                      )}
                    </Row>

                    {/* old Note commented bcz of new changes made in this form */}
                    {/* <h5 className="note">
                      Note :- Please scan the device and get the data from
                      dispenser.
                    </h5> */}

                    {/* ---------------------------------------------------------------- dispenser data
        ---------------------------------------------------------------- */}
                    {!(oprationType === "Rate Change" || oprationType === "Time Change" || oprationType === "Date Change") && (
                      <div className="main-form">
                        {/* //{show && Hide*/}
                        {show ? (
                          <Form>
                            <hr />
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Model Name
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.modelName}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            <h5 style={{ textAlign: "left", color: "#004417" }}>
                              Motherboard (MCU)
                            </h5>
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Firmware Version No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardSoftwareSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Hardware Version{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardHardwareVersion}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Serial No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">SHA2</label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardSHA2}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Sign X-509-64 Bit Block{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardSignXBitBlock}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Private Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardPrivateKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    RCA Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardRCAPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            <h5 style={{ textAlign: "left", color: "#004417" }}>
                              Totalizer (TOT)
                            </h5>
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Firmware Version No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1SoftwareSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Hardware Version{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1HardwareVersion}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Serial No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1BoardSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">SHA2</label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1BoardSHA2}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Sign X-509-64 Bit Block{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1SignXBitBlock}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1PublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Private Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1PrivateKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    RCA Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1RCAPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            {csd.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "#004417",
                                  }}
                                >
                                  Customer Display (CSD-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`csd${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`csd${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {mre.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "#004417",
                                  }}
                                >
                                  Pulser (MRE-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`mre${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`mre${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {lkd.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "#004417",
                                  }}
                                >
                                  Operator Keypad Display (LKD-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`lkd${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`lkd${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {/* ---------------------------------------------------------------- Vapor Recovery (VR) */}
                            {pvr.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                  Vapor Recovery (VR-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`pvr${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`pvr${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {/* ---------------------------------------------------------------- Printer (Printer) */}
                            {prn.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                  Printer (Printer-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`prn${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`prn${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </Form>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </Form>
                </>
                {/* ) : (
                  <NotScanned />
                )} */}
              </Card.Body>
            </Card>
          </>
        );
      }}
    </Formik>
  );
};







// import * as Yup from "yup";

// import {
//   Button,
//   Card,
//   Col,
//   Dropdown,
//   InputGroup,
//   Row,
// } from "@themesberg/react-bootstrap";
// import { ErrorMessage, Field, Form, Formik } from "formik";
// import React, { useEffect, useState } from "react";
// import {
//   getAllDataOfDispenserSrNo,
//   getDataScannedOrNot,
//   getFieldIssueDetailsGetData,
//   postFieldIssue,
//   postFieldIssuecloseworkorder,
//   postGetotpDetailsFieljob
// } from "../../Service/AllServicesAPI";
// import { deleteOtp, fetchOtp } from "../../Service/AllProductionAPI"
// import {
//   getCustomerList,
//   getDealerList,
//   getServiceEngineerList,
// } from "../master/AllUserDropDown";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAngleLeft, faBackward, faClipboard, faStepBackward } from "@fortawesome/free-solid-svg-icons";
// import { Link } from "react-router-dom";
// import DatePicker from "react-datepicker";
// import NotScanned from "../NotScanned";
// import Select from "react-select";
// import Swal from "sweetalert2";
// import TextError from "../TextError";
// import ToolTip from "../ToolTip";
// import moment from "moment-timezone";
// import swal from "sweetalert";
// import { useLocation } from "react-router-dom";

// import OtpFormBased from "../../components/OtpFormBased";
// // const validationSchema = Yup.object().shape({
// //   arkNo: Yup.string().required("Required *"),
// //   //oprationType: Yup.string().required("Required *"),
// //   // subOprationType: Yup.string().required("Required *"),
// //   volumeTotalizer: Yup.string().required("Required *"),
// //   jobNo: Yup.string().required("Required *"),
// //   siteAddress: Yup.string().required("Required *"),
// //   remark: Yup.string().required("Required *"),
// // .matches(
// //   /^[0-9]+\.\d{2}$/,
// //   "Please enter random digits followed by a dot and two digits (e.g., 365.21)"
// // )
// // .test(
// //   "is-valid-volume",
// //   "Please enter random digits followed by a dot and two digits (e.g., 365.21)",
// //   (value) => {
// //     const parts = value.split(".");
// //     const integerPart = parts[0];
// //     const solidInteger = /^(?!0{2,})[0-9]+$/.test(integerPart);
// //     return solidInteger;
// //   }
// // ),

// //   uploadDispenserPhoto: Yup.mixed()
// //     .required("Image is required")
// //     .test("is-image", "Only image files are allowed", (value) => {
// //       if (!value) return false;
// //       return (
// //         value &&
// //         [
// //           "image/jpeg",
// //           "image/png",
// //           "image/gif",
// //           "image/webp",
// //           "image/jpg",
// //         ].includes(value.type)
// //       );
// //     }),
// // });

// export default (props) => {
//   const [show, setShow] = useState(false);
//   const [csd, setCsd] = useState([1]);
//   const [mre, setMre] = useState([1]);
//   const [lkd, setLkd] = useState([1]);

//   // newly added board vr and printer
//   const [pvr, setPvr] = useState([1]);
//   const [prn, setPrn] = useState([1]);

//   const location = useLocation();
//   const [workOrder, setWorkOrder] = useState("");
//   const [role, setRole] = useState(sessionStorage.getItem("role"));
//   const [processData, setProcessData] = useState([]);
//   const [dispenserSrNo, setDispenserSrNo] = useState("");
//   const [selected, setSelected] = useState("");
//   let type = null;
//   const [oprationType, setOprationType] = useState("");
//   const [subOprationType, setSubOprationType] = useState("");
//   const [dealerMblNo, setDealerMblNo] = useState("");
//   const [serviceEngineerNm, setServiceEngineerNm] = useState("");
//   const [userMblNo, setUserMblNo] = useState("");
//   const [siteType, setSiteType] = useState("");
//   const [siteNm, setSiteNm] = useState("");
//   const [serviceEngineerName, setServiceEngineerName] = useState([]);
//   const [customerNm, setCustomerNm] = useState("");
//   const [dealerName, setDealerName] = useState([]);
//   const [customerName, setCustomerName] = useState([]);
//   const [customerMblNo, setCustomerMblNo] = useState("");
//   const [dealerNm, setDealerNm] = useState("");
//   const [serviceEngineerId, setServiceEngineerId] = useState("");
//   const [dealerId, setDealerId] = useState([]);
//   const [customerId, setCustomerId] = useState("");
//   const [curreLocation, setCurreLocation] = useState({});
//   const [isLoaded, setisLoaded] = useState(false);
//   const [prodT, setProdT] = useState("");
//   const [showForm, setShowForm] = useState(false);
//   const [startDate, setStartDate] = useState("");
//   const [selectedTime, setSelectedTime] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [base64Image, setBase64Image] = useState("");
//   const [uploadedImage, setUploadedImage] = useState(null);
//   const [filedDispenserphoto, SetfiledDispenserphoto] = useState('');
//   const [arkNo, setArkNo] = useState("");
//   const [volumeTotalizer, setVolumeTotalizer] = useState("");
//   const [jobNo, setJobNo] = useState("");
//   const [siteAddress, setSiteAddress] = useState("")
//   const [selectedJobType, setSelectedJobType] = useState("OTP");
//   const [Desc, setDesc] = useState("");
//   const [showToast, setShowToast] = useState(true);
//   const [otp, setOtp] = useState(null);
//   // loading text in button 
//   const [loadingbutton, setLoadingbutton] = useState(false);
//   // toggle of otp and close field job form fields
//   const [isVerifyEnabled, setVerifyEnabled] = useState(true);
//   const [isOtpEnabled, setOtpEnabled] = useState(true);

//   // disable and enable get otp button after 1 minutues
//   const [isOtpdisable, setOtpdisable] = useState(true);

//   // close field job button disable
//   const [isButtonDisabled, setIsButtonDisabled] = useState(false);
//   // image validation to keep button disable
//   const [iscalibrationstartcloseEnables, setButtonDisabled] = useState(true);

//   // button name change based on operation type
//   const [buttonText, setButtonText] = useState('Get OTP');

//   const [modelName, setModelName] = useState('');

//   const [closeComp, SetCloseComp] = useState(true);

//   const [pkFieldotpId, setpkFieldotpId] = useState(null);

//   const handleTimeChange = (e) => {
//     setSelectedTime(e.target.value);
//   };

//   const formatTimeTo12Hour = (time24) => {
//     const [hour, minute, second] = time24.split(":");
//     const parsedHour = parseInt(hour, 10);
//     const period = parsedHour >= 12 ? "PM" : "AM";
//     const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
//     return `${formattedHour}:${minute}:${second} ${period}`;
//   };

//   const displayFormattedTime = selectedTime
//     ? formatTimeTo12Hour(selectedTime)
//     : "";

//   useEffect(() => {
//     document.addEventListener("keydown", function (event) {
//       if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
//         var form = event.target.form;
//         var index = Array.prototype.indexOf.call(form, event.target);
//         form.elements[index + 1].focus();
//         event.preventDefault();
//       }
//     });
//   }, []);

//   useEffect(() => {
//     fetchOtpFromApi();
//   }, []);

//   useEffect(() => {
//     if (!(oprationType === "Rate Change" || oprationType === "Time Change" || oprationType === "Date Change")) {
//       setSelectedJobType("otp");
//       setButtonText('Get OTP');
//     } else {
//       setSelectedJobType('nonotp'); // Reset or set a default if needed
//       setButtonText('Send Data');
//     }
//   }, [oprationType]);

//   useEffect(() => {
//     getCustomersList();
//     getServiceEngineersList();
//     getDealersList();

//     geolocation();
//     if (role === "service engineer") {
//       const { data } = location.state;
//       console.log("GetDispenser data :-", data);
//       setWorkOrder(data.workOrderSerialNo);
//       setDispenserSrNo(data.generateUniqueDispenserNo);
//       // getDataScanOrNot(data.generateUniqueDispenserNo);
//       getAllDataOfDispenSrNo(data.generateUniqueDispenserNo);
//       setCustomerNm(data.customerName); //siteType
//       setCustomerMblNo(data.customerMobNo);
//       setServiceEngineerNm(data.serviceEngineerName);
//       setServiceEngineerId(data.fkServiceEngineerId);
//       setUserMblNo(data.serviceEngineerMobNo);
//       setDealerNm(data.dealerName);
//       setDealerMblNo(data.dealerMobNo);
//       setSiteType(data.siteType);
//       setSiteNm(data.siteLocation);
//       setDealerId(data.fkDealerId);
//       setCustomerId(data.fkCustomerId);
//       setOprationType(data.oprationType);
//       setSubOprationType(data.subOprationType);
//       // setProdT(data.productType);
//     }
//     // eslint-disable-next-line
//   }, []);



//   // Function declaration of get customers list
//   const getCustomersList = async () => {
//     await getCustomerList().then((result) => {
//       setCustomerName(result);
//     });
//   };

//   // Function declaration of get Service Engineers list
//   const getServiceEngineersList = async () => {
//     await getServiceEngineerList().then((result) => {
//       setServiceEngineerName(result);
//     });
//   };
//   // Function declaration of get Dealer list
//   const getDealersList = async () => {
//     await getDealerList().then((result) => {
//       setDealerName(result);
//     });
//   };

//   const geolocation = () => {
//     if (!navigator.geolocation) {
//       // swal("Failed", "Geolocation is not supported in your browser", "warning");
//       console.log("Geolocation is not supported in your browser");
//     } else {
//       navigator.geolocation.getCurrentPosition((position) => {
//         console.log("Position :-", position);
//         const { latitude, longitude } = position.coords;
//         console.log("latitude, longitude :-", latitude, longitude);
//         setCurreLocation({ latitude, longitude });
//       });
//     }
//   };

//   const alertMessage = () => {
//     Swal.fire({
//       position: "top-center",
//       title: "Please scan the device and get the data from dispenser.",
//       showConfirmButton: false,
//       timer: 3000,
//     });
//   };

//   const selectjob = [
//     { value: "otp", label: "OTP" },
//     { value: "nonotp", label: "NON OTP" },
//   ];

//   // old initially scanning functionality 
//   // const getDataScanOrNot = (disSrNo) => {
//   //   const token = sessionStorage.getItem("token");
//   //   const headers = { Authorization: `Bearer ${token}` };
//   //   console.log("dispenserSrNo :-", disSrNo);
//   //   getDataScannedOrNot(disSrNo, headers)
//   //     .then((result) => {
//   //       console.log("getDataScannedOrNot result :-", result);
//   //       if (result.data.message === "dispenser data is scaned successfully") {
//   //         // setShowForm(true);
//   //       } else {
//   //         // swal(
//   //         //   "Failed",
//   //         //   "Dispenser data is not scanned for this dispenser No",
//   //         //   "warning"
//   //         // );
//   //         console.log("Dispenser data is not scanned for this dispenser No")
//   //       }
//   //     })
//   //     .catch((error) => {
//   //       console.log("getDataScannedOrNot error :-", error);
//   //     });
//   // };



//   const getAllDataOfDispenSrNo = (disSrNo) => {
//     const token = sessionStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${token}` };
//     console.log("dispenserSrNo :-", disSrNo);
//     getAllDataOfDispenserSrNo(disSrNo, headers)
//       .then((result) => {
//         console.log("getAllDataOfDispenSrNo result to check model name :-", result);
//         setProdT(result.data.productType);
//         setModelName(result.data.modelName);
//       })
//       .catch((error) => {
//         console.log("getAllDataOfDispenSrNo error :-", error);
//       });
//   };

//   const selectOTPtype = [
//     { value: "Marry New Hardware", label: "Marry New Hardware" },
//     { value: "Marry New Firmware", label: "Marry New Firmware" },
//     { value: "Rate Change", label: "Rate Change" },
//     { value: "Supervisor Unlock", label: "Supervisor Unlock" },
//     { value: "Clear magnet error", label: "Clear magnet error" },
//     {
//       value: "Reconnect MRE (Pulsar)",
//       label: "Reconnect MRE (Pulsar)",
//     },
//     { value: "To Open ERA Door", label: "To Open ERA Door" },
//     { value: "To Close ERA Door", label: "To Close ERA Door" },
//     { value: "To Open Hydraulic Door", label: "To Open Hydraulic Door" },
//     { value: "To Close Hydraulic Door", label: "To Close Hydraulic Door" },
//     {
//       value: "To Mandate Pulsar Back To Mapped Nozzle",
//       label: "To Mandate Pulsar Back To Mapped Nozzle",
//     },
//     { value: "Date Change", label: "Date Change" },
//     { value: "Time Change", label: "Time Change" },
//     // { value: "hangingHardwareChange", label: "Hanging Hardware Change"}
//   ];

//   //    Allow To Reconnect Of Same MRE (
//   // Pulsar
//   // )

//   const disabledOptions = [6, 7, 8, 9, 10];

//   const MarryNewBoard = [
//     { value: "ETOT/MEM Board", label: "ETOT/MEM Board" },
//     { value: "CSD Board", label: "CSD Board" },
//     { value: "LKD Board", label: "LKD Board" },
//     { value: "MCU Board", label: "MCU Board" },
//     { value: "MRE (Pulsar) Board", label: "MRE (Pulsar) Board" },
//   ];

//   const MarryNewHardware = [
//     { value: "ETOT/MEM Board", label: "ETOT/MEM Board" },
//     { value: "CSD Board", label: "CSD Board" },
//     { value: "LKD Board", label: "LKD Board" },
//     { value: "MCU Board", label: "MCU Board" },
//     { value: "MRE (Pulsar) Board", label: "MRE (Pulsar) Board" },
//     { value: "PRN Board", label: "PRINTER Board" },
//     { value: "PVR Board", label: "VAPOR RECOVERY Board" },
//   ];

//   const startCalibration = [
//     { value: "Nozzle 1", label: " Nozzle 1" },
//     { value: "Nozzle 2", label: " Nozzle 2" },
//     { value: "Nozzle 3", label: " Nozzle 3" },
//     { value: "Nozzle 4", label: " Nozzle 4" },
//     { value: "Nozzle 5", label: " Nozzle 5" },
//     { value: "Nozzle 6", label: " Nozzle 6" },
//     { value: "Nozzle 7", label: " Nozzle 7" },
//     { value: "Nozzle 8", label: " Nozzle 8" },
//   ];

//   const endCalibration = [
//     { value: "Nozzle 1", label: " Nozzle 1" },
//     { value: "Nozzle 2", label: " Nozzle 2" },
//     { value: "Nozzle 3", label: " Nozzle 3" },
//     { value: "Nozzle 4", label: " Nozzle 4" },
//     { value: "Nozzle 5", label: " Nozzle 5" },
//     { value: "Nozzle 6", label: " Nozzle 6" },
//     { value: "Nozzle 7", label: " Nozzle 7" },
//     { value: "Nozzle 8", label: " Nozzle 8" },
//   ];

//   const rateChange = [
//     { value: "Concerned Product", label: "Concerned Product" },
//     // { value: "Nozzle 2", label: "Nozzle 2" },
//     // { value: "Nozzle 3", label: "Nozzle 3" },
//     // { value: "Nozzle 4", label: "Nozzle 4" },
//     // { value: "Nozzle 5", label: "Nozzle 5" },
//     // { value: "Nozzle 6", label: "Nozzle 6" },
//     // { value: "Nozzle 7", label: "Nozzle 7" },
//     // { value: "Nozzle 8", label: "Nozzle 8" },
//     // { value: "Product No. 1", label: "Product No 1" },
//     // { value: "Product No. 2", label: "Product No 2" },
//     // { value: "Product No. 3", label: "Product No 3" },
//     // { value: "Product No. 4", label: "Product No 4" },
//   ];

//   const supervisorUnlock = [
//     { value: "Supervisor Unlock", label: "Supervisor Unlock" },
//   ];

//   const clearmagneterror = [
//     { value: "MRE (Pulsar) Board 1", label: "MRE (Pulsar) Board 1" },
//     { value: "MRE (Pulsar) Board 2", label: "MRE (Pulsar) Board 2" },
//     { value: "MRE (Pulsar) Board 3", label: "MRE (Pulsar) Board 3" },
//     { value: "MRE (Pulsar) Board 4", label: "MRE (Pulsar) Board 4" },
//     { value: "MRE (Pulsar) Board 5", label: "MRE (Pulsar) Board 5" },
//     { value: "MRE (Pulsar) Board 6", label: "MRE (Pulsar) Board 6" },
//     { value: "MRE (Pulsar) Board 7", label: "MRE (Pulsar) Board 7" },
//     { value: "MRE (Pulsar) Board 8", label: "MRE (Pulsar) Board 8" },
//   ];
//   const toMandatepulsarbacktomappednozzle = [
//     { value: "Nozzle 1", label: "Nozzle 1" },
//     { value: "Nozzle 2", label: "Nozzle 2" },
//     { value: "Nozzle 3", label: "Nozzle 3" },
//     { value: "Nozzle 4", label: "Nozzle 4" },
//     { value: "Nozzle 5", label: "Nozzle 5" },
//     { value: "Nozzle 6", label: "Nozzle 6" },
//     { value: "Nozzle 7", label: "Nozzle 7" },
//     { value: "Nozzle 8", label: "Nozzle 8" },
//   ];

//   const dateChange = [{ value: "Date Change", label: "Date Change" }];

//   const timeChange = [{ value: "Time Change", label: "Time Change" }];

//   // const hangingHardwareChange = [
//   //   { value: "mcuChange", label: "MCU Change" },
//   //   { value: "totChange", label: "TOT Change" },
//   //   { value: "lkdChange", label: "LKD Change" },
//   // ];

//   //Conditon for operation Type filter

//   if (selected === "Marry New Hardware") {
//     type = MarryNewHardware;
//   } else if (selected === "Marry New Firmware") {
//     type = MarryNewBoard;
//   } else if (selected === "Calibration Start") {
//     type = startCalibration;
//   } else if (selected === "End Calibration") {
//     type = endCalibration;
//   } else if (selected === "Rate Change") {
//     type = rateChange;
//   } else if (selected === "Supervisor Unlock") {
//     type = supervisorUnlock;
//   } else if (selected === "Clear magnet error") {
//     type = clearmagneterror;
//   } else if (selected === "Reconnect MRE (Pulsar)") {
//     type = clearmagneterror;
//   } else if (selected === "To Open ERA Door") {
//     type = startCalibration;
//   } else if (selected === "To Close ERA Door") {
//     type = startCalibration;
//   } else if (selected === "To Open Hydraulic Door") {
//     type = startCalibration;
//   } else if (selected === "To Close Hydraulic Door") {
//     type = startCalibration;
//   } else if (selected === "To Mandate Pulsar Back To Mapped Nozzle") {
//     type = toMandatepulsarbacktomappednozzle;
//   } else if (selected === "Date Change") {
//     type = dateChange;
//   } else if (selected === "Time Change") {
//     type = timeChange;
//     // } else if (selected === "hangingHardwareChange") {
//     //   type = hangingHardwareChange;
//   }

//   // Added new boards in modelQty (prn and pvr)  with other boards (csd,mre,lkd) and (Mcu,Tot)

//   const modelQty = [
//     {
//       modelNo: "1111",
//       csd: [1],
//       mre: [1],
//       lkd: [1],
//       prn: [1],
//       pvr: [1],
//     },
//     {
//       modelNo: "1121",
//       csd: [1, 1],
//       mre: [1],
//       lkd: [1],
//       prn: [1],
//       pvr: [1],
//     },
//     {
//       modelNo: "1222",
//       csd: [1, 1],
//       mre: [1, 1],
//       lkd: [1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "2222",
//       csd: [1, 1],
//       mre: [1, 1],
//       lkd: [1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "2422",
//       csd: [1, 1],
//       mre: [1, 1, 1, 1],
//       lkd: [1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "3622",
//       csd: [1, 1],
//       mre: [1, 1, 1, 1, 1, 1],
//       lkd: [1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "4822",
//       csd: [1, 1],
//       mre: [1, 1, 1, 1, 1, 1, 1, 1],
//       lkd: [1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "1242",
//       csd: [1, 1, 1, 1],
//       mre: [1, 1],
//       lkd: [1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "2242",
//       csd: [1, 1, 1, 1],
//       mre: [1, 1],
//       lkd: [1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "1444",
//       csd: [1, 1, 1, 1],
//       mre: [1, 1, 1, 1],
//       lkd: [1, 1, 1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "2444",
//       csd: [1, 1, 1, 1],
//       mre: [1, 1, 1, 1],
//       lkd: [1, 1, 1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "3644",
//       csd: [1, 1, 1, 1],
//       mre: [1, 1, 1, 1, 1, 1],
//       lkd: [1, 1, 1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//     {
//       modelNo: "4844",
//       csd: [1, 1, 1, 1],
//       mre: [1, 1, 1, 1, 1, 1, 1, 1],
//       lkd: [1, 1, 1, 1],
//       prn: [1, 1],
//       pvr: [1],
//     },
//   ];

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     setSelectedFile(file);
//   };




//   const uploadImg = (e) => {
//     console.log("uploadImg :-", e.target.files[0]);
//     const file = e.target.files[0];
//     console.log("file :-", file);

//     if (file) {
//       // Check if the file is an image
//       if (!file.type.startsWith('image/')) {
//         // If the file is not an image, set the error message
//         SetfiledDispenserphoto("Please upload an image file.");
//         setButtonDisabled(true);
//         return;
//       }

//       // Check if the image size exceeds 100 KB
//       if (file.size > 100 * 1024) { // 100 KB in bytes
//         // If the image size exceeds 100 KB, set the error message
//         SetfiledDispenserphoto(
//           <p>
//             The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
//             <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank">
//               <span style={{ color: 'blue', textDecoration: 'none' }}>https://image.pi7.org/reduce-image-size-in-kb</span>
//             </a>.
//           </p>
//         );
//         setButtonDisabled(true);
//         return;
//       }

//       // If the file is an image and size is within limits, proceed with reading it
//       const reader = new FileReader();
//       reader.onload = () => {
//         setBase64Image(reader.result);
//         setButtonDisabled(false);
//       };
//       reader.readAsDataURL(file);
//       setUploadedImage(file);
//     }
//   };


//   // select otp or non otp functionality without using inbuilt formik
//   const handleChange = (selectedOption) => {
//     setSelectedJobType(selectedOption ? selectedOption.value : '');
//   };





//   // This function is used to get OTP and verify ARK on the click of the "Get OTP" button
//   const HandleSendOtpFieldjob = async () => {

//     setLoadingbutton(true)
//     const token = sessionStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${token}` };

//     const payload = {
//       workOrderSerialNo: workOrder,
//       productType: prodT,
//       modelName: modelName,
//       generateUniqueDispenserNo: dispenserSrNo,
//       arkNo: arkNo,
//       oprationType: oprationType,
//       subOprationType: subOprationType,
//       volumeTotalizer: volumeTotalizer,
//       jobNo: jobNo,
//       fieldIssueDate: moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
//       fieldIssueTime: moment(displayFormattedTime, "hh:mm:ss A").format("hh:mm:ss A"),
//       fkDealerId: dealerId,
//       customerName: customerNm,
//       customerMobileNo: customerMblNo,
//       siteType: siteType,
//       dealerName: dealerNm,
//       fkCustomerId: customerId,
//       description: Desc,
//       dealerMobileNo: dealerMblNo,
//       fkServiceEngineerId: serviceEngineerId,
//       serviceEngineerName: serviceEngineerNm,
//       serviceEngineerMobNo: userMblNo,
//       longitude: curreLocation.longitude,
//       latitude: curreLocation.latitude,
//       siteName: siteNm,
//       jobType: selectedJobType,
//       siteAddress: siteAddress,
//     };

//     // Disable OTP button immediately
//     setOtpdisable(true);

//     try {
//       // Send the request to get OTP
//       const response = await postGetotpDetailsFieljob(payload, headers);

//       const { message, status } = response.data;

//       if (status === 200) {
//         if (message === "First Generate ARK ON Dispenser Then, SCAN.") {
//           swal("", message, "info");
//         } else if (message === "Scanning Required..") {
//           swal("", message, "warning");
//         } else if (message === "INVALID Operation Type And SubOperation Type..") {
//           swal("", message, "warning");
//         } else if (message === "PKI Server is down..") {
//           swal("", message, "info");
//         } else if (message === "ARK verification Failed") {
//           swal("", message, "error");
//         } else if (message === "Your Scanning for wrong Dispenser Serial Number..") {
//           swal("", "Your Scanning for wrong Dispenser Serial Number...", "error");
//         } else if (message === "FieldIssue details added successfully") {
//           swal("Great", message, "success");
//           setLoadingbutton(false)
//           setOtpdisable(false);
//           setTimeout(() => {
//             setOtpdisable(true);
//           }, 60000);

//         } else {
//           swal("Error", "Unexpected response message", "error");
//         }
//       } else {
//         swal("Error", "Unexpected status code", "error");
//       }
//     } catch (error) {
//       console.log("Error sending OTP:", error);
//       swal("Failed", "Error sending OTP", "error");

//       // Re-enable OTP button in case of error
//       // setOtpdisable(false);
//     }
//     finally {

//       setLoadingbutton(false)
//     }
//   };






//   // old payload of feild job form 

//   // productType: prodT,
//   // arkNo: values.arkNo,
//   // oprationType: oprationType,
//   // subOprationType: subOprationType,
//   // volumeTotalizer: values.volumeTotalizer,
//   // jobNo: values.jobNo,
//   // fieldIssueDate: moment(startDate, "yyyy-MM-DD").format(
//   //   "yyyy-MM-DD"
//   // ),
//   // fieldIssueTime: moment(displayFormattedTime, "hh:mm:ss A").format(
//   //   "hh:mm:ss A"
//   // ),
//   // fkServiceEngineerId: serviceEngineerId,
//   // serviceEngineerName: serviceEngineerNm,
//   // serviceEngineerMobNo: userMblNo,
//   // siteType: siteType,
//   // siteName: siteNm,
//   // fkCustomerId: customerId,
//   // customerName: customerNm,
//   // customerMobileNo: customerMblNo,
//   // fkDealerId: dealerId,
//   // dealerName: dealerNm,
//   // dealerMobileNo: dealerMblNo,
//   // siteAddress: values.siteAddress,
//   // longitude: curreLocation.longitude,
//   // latitude: curreLocation.latitude,
//   // jobType: values.jobType,


//     const fetchOtpFromApi = async () => {
//       const token = sessionStorage.getItem("token");
//       const fkUserId = sessionStorage.getItem("pkUserId");

//       if (fkUserId) {
//         try {
//           const fetchedOtp = await fetchOtp(fkUserId, token);
//           console.error("Formbased  Fetech api otp....................", fetchedOtp);

//           if (fetchedOtp) {
//             setOtp(fetchedOtp);
//             setpkFieldotpId(fetchedOtp.data.pkFieldotpId);
//           }
//         } catch (error) {
//           console.error("Error during OTP fetch:", error);
//         }
//       } else {
//         console.error("No fkUserId found in sessionStorage.");
//       }
//     };

  


//   const handleDeleteClick = async () => {
//     console.log("Calling deleteOtp with ID:", pkFieldotpId);

//     try {
//       const result = await deleteOtp(pkFieldotpId);
//       console.log("Delete result:", result);  // Log the whole result object

//       if (result) {
//         alert('OTP deleted successfully');
//       } else {
//         alert('OTP deletion failed');
//       }
//     } catch (error) {
//       console.error("Error caught in handleDeleteClick:", error);
//       alert('Failed to delete OTP');
//     }
//   };




//   const Handlesubmitfiledjob = async (values, { resetForm }) => {
//     try {

//       const pkUserId = sessionStorage.getItem("pkUserId");
//       let data = {
//         generateUniqueDispenserNo: dispenserSrNo,
//         workOrderSerialNo: workOrder,
//         remark: values.remark,
//         uploadDispenserPhoto: base64Image,

//       };
//       console.log("GetFieldDispenser check  data of post fild issue :-", data);
//       const token = sessionStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${token}` };

//       await postFieldIssuecloseworkorder(data, headers)
//         .then((result) => {
//           console.log("result of field issue :-", result);
//           const message = result.data.message;
//           if (message === "ARK verification Failed Here") {
//             setisLoaded(false);
//             swal("Failed", "ARK verification failed here", "error");
//           } else if (message.includes("dispenser data is not scaned for this work order addFieldIssueDetailsX")) {
//             swal("Warning", "Dispenser data is not scanned for this work order", "warning");
//           } else if (message === "PKI Server is down..here") {
//             swal("", "PKI Server is down here", "info");
//           } else if (message === "FieldIssue Work Order Not Valid") {
//             swal("", "FieldIssue Work Order is Not Valid", "info");
//           } else if (message === "FieldIssue Work Order Not Valid") {
//             swal("Warning", "FieldIssue Work Order is not valid", "warning");
//           } else if (message === "FieldIssue Work Order Closed successfully") {
//             swal("Great", "FieldIssue Work Order Closed successfully", "success");
//             SetCloseComp(false)
//             setIsButtonDisabled(true);
//             setTimeout(() => {
//               window.location.href = "serviceModule/verification-fieldIssue-list";
//             }, 7000);


//           }


//         })
//         .catch((error) => {
//           console.log("Field Issue Error :-", error);
//           setisLoaded(false);
//           if (error.response.status === 404) {
//             swal("Failed", `Failed to close field issue `, "warning");

//           } else if (error.response.data.status === 500) {
//             swal("Failed", `${error.response.data.message}`, "warning");
//           }
//         });
//     } catch (error) {
//       console.log(error);
//       swal("Failed", "Failed to close field issue", "error");

//     }
//   }


//   return (
//     <Formik
//       initialValues={{
//         generateUniqueDispenserNo: "",
//         workOrderSerialNo: "",
//         remark: "",
//         uploadDispenserPhoto: "",

//       }}
//       // validationSchema={validationSchema}
//       onSubmit={Handlesubmitfiledjob}


//     >
//       {(formik) => {
//         const { isValid, dirty, isSubmitting, values } = formik;
//         const isGetOtpButtonEnabled = !(oprationType === "Rate Change" || oprationType === "Time Change" || oprationType === "Date Change")
//           ? arkNo && volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && Desc
//           : volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && Desc; // arkNo is not required for these operation types
//         const isVerifyButtonEnabled = arkNo;
//         const isgetotpButtonEnabled = volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && Desc;
//         const isfieldjobButtonEnabled = volumeTotalizer && jobNo && startDate && displayFormattedTime && selectedJobType && siteAddress && values.uploadDispenserPhoto && values.remark && Desc;
//         return (
//           <>
//             <div className="d-flex mb-2">
//               <Link
//                 to="verification-fieldIssue-list"
//                 className="fieldLink btn btn-primary"
//               >
//                 <FontAwesomeIcon icon={faAngleLeft} className="me-2" />{" "}
//                 My Jobs
//                 <span className="icon icon-small ms-1"></span>
//               </Link>

//             </div>
//             <Card border="light" className="bg-white shadow-sm mb-4">

//               <Card.Body>
//                 {/* {showForm ? ( */}
//                 <>
//                   <h5 className="head mb-4">Submit Field Job</h5>

//                   {closeComp ?
//                     <OtpFormBased /> : ""}

//                   <Form>
//                     <Row>
//                       {/* <Col md={6}> <Button onClick={handleDeleteClick}>Delete OTP</Button></Col> */}
                     
//                       <Col md={6} className="mb-3">
//                         <div className="form-group">
//                           <label className="lable mb-1">
//                             {" "}
//                             Job Type *{" "}
//                           </label>
//                           <div className="example-wrapper">
//                             <ToolTip
//                               content="Select Job Type"
//                               direction="bottom"
//                             >
//                               <Field
//                                 type="text"
//                                 className="form-control"
//                                 name="workOrderNo"
//                                 placeholder="OTP or NON OTP"
//                                 value={selectedJobType === 'otp' ? 'OTP' : 'Non OTP'}
//                                 readOnly
//                               />
//                             </ToolTip>
//                           </div>
//                           <ErrorMessage
//                             name="jobType"
//                             component={TextError}
//                           />
//                         </div>

//                       </Col>
//                       <Col md={6} className="mb-3">
//                         <div className="form-group">
//                           <label className="Label mb-1">
//                             {" "}
//                             Dispenser Configuration
//                           </label>
//                           <Field
//                             type="text"
//                             className="form-control"
//                             name="modelName"
//                             placeholder="Disp Type"
//                             value={modelName}
//                             readOnly
//                           />
//                         </div>
//                       </Col>
//                       <Col md={6} className="mb-3">
//                         <div className="form-group">
//                           <label className="Label mb-1">
//                             {" "}
//                             Work Order No.{" "}
//                           </label>
//                           <Field
//                             type="text"
//                             className="form-control"
//                             name="workOrderNo"
//                             placeholder="Work Order No."
//                             value={workOrder}
//                             readOnly
//                           />
//                         </div>
//                       </Col>

//                       <Col md={6} className="mb-3">
//                         <div className="form-group">
//                           <label className="Label mb-1">
//                             {" "}
//                             Dispenser Serial No
//                           </label>
//                           <Field
//                             type="text"
//                             className="form-control"
//                             name="generateUniqueDispenserNo"
//                             placeholder="Dispenser Serial No."
//                             value={dispenserSrNo}
//                             readOnly
//                           />
//                         </div>

//                       </Col>
//                       <Col md={6} className="mb-3">
//                         <div className="form-group">
//                           <label className="Label mb-1"> Product Type </label>
//                           <Field
//                             placeholder="Select Product Type"
//                             className="form-control"
//                             value={prodT}
//                             readOnly
//                           />
//                         </div>
//                       </Col>

//                       {!(oprationType === "Rate Change" || oprationType === "Time Change" || oprationType === "Date Change") && (
//                         <Col md={6} className="mb-3">
//                           <div className="form-group">
//                             <label className="LabelNew mb-1">ARK No</label>
//                             <div className="example-wrapper">
//                               <ToolTip
//                                 content="Enter ARK no"
//                                 direction="bottom"
//                               >
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   // name="arkNo"
//                                   value={arkNo}
//                                   placeholder="Enter ARK No."
//                                   autoComplete="off"
//                                   // onChange={(e) => setArkNo(e.target.value)}
//                                   onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (/^[A-Z0-9]*$/.test(value) && value.length <= 6) {
//                                       setArkNo(value);
//                                     }
//                                   }}
//                                 />
//                               </ToolTip>
//                             </div>
//                             <ErrorMessage name="arkNo" component={TextError} />
//                           </div>
//                         </Col>
//                       )}

//                       <Col md={6} className="mb-3">
//                         <div className="form-group">
//                           <label className="lable mb-1">
//                             {" "}
//                             Operation Type *{" "}
//                           </label>
//                           <div className="example-wrapper">
//                             <ToolTip
//                               content="Select Operation Type"
//                               direction="bottom"
//                             >
//                               {/* <Select
//                                   name="oprationType"
//                                   title="Select OTP"
//                                   placeholder="Select OTP"
//                                   options={selectOTPtype}
//                                   isOptionDisabled={(option) =>
//                                     disabledOptions.includes(
//                                       selectOTPtype.indexOf(option)
//                                     )
//                                   }
//                                   onChange={(e) => {
//                                     formik.setFieldValue(
//                                       "oprationType",
//                                       e.value
//                                     );
//                                     setSelected(e.value);
//                                   }}
//                                 /> */}
//                               <Field
//                                 name="oprationType"
//                                 className="form-control"
//                                 placeholder="Select Operation Type"
//                                 value={oprationType}
//                                 readOnly
//                               />
//                             </ToolTip>
//                           </div>
//                           {/* <ErrorMessage
//                               name="oprationType"
//                               component={TextError}
//                             /> */}
//                         </div>

//                       </Col>
//                       <Col md={6} className="mb-3">
//                         <div className="form-group">
//                           <label className="lable mb-1">
//                             {" "}
//                             Sub Operation Type *{" "}
//                           </label>
//                           <div className="example-wrapper">
//                             <ToolTip
//                               content="Select Sub Operation"
//                               direction="bottom"
//                             >
//                               {/* <Select
//                                   name="subOprationType"
//                                   title=""
//                                   placeholder="Select Sub Operation"
//                                   options={type}
//                                   onChange={(e) => {
//                                     formik.setFieldValue(
//                                       "subOprationType",
//                                       e.value
//                                     );
//                                   }}
//                                 /> */}
//                               <Field
//                                 name="subOprationType"
//                                 className="form-control"
//                                 placeholder="Select OTP"
//                                 value={subOprationType}
//                                 readOnly
//                               />
//                             </ToolTip>
//                           </div>
//                           {/* <ErrorMessage
//                               name="subOprationType"
//                               component={TextError}
//                             /> */}
//                         </div>
//                       </Col>
//                       {isVerifyEnabled && (
//                         <>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="LabelNew mb-1">
//                                 {" "}
//                                 Volume Totalizer *{" "}
//                               </label>
//                               <div className="example-wrapper">
//                                 <ToolTip
//                                   content="Enter Volume Totalizer"
//                                   direction="bottom"
//                                 >
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     // name="volumeTotalizer"
//                                     value={volumeTotalizer}
//                                     // onChange={(e) => setVolumeTotalizer(e.target.value)}
//                                     onChange={(e) => {
//                                       const value = e.target.value;
//                                       if (/^\d*\.?\d*$/.test(value)) {
//                                         setVolumeTotalizer(value);
//                                       }
//                                     }}
//                                     placeholder="Enter Volume Totalizer"
//                                     autoComplete="off"
//                                   // onInput={(e) => {
//                                   //   e.target.value = e.target.value.replace(
//                                   //     /[^\d.]+/g,
//                                   //     ""
//                                   //   );
//                                   // }}
//                                   />
//                                 </ToolTip>
//                               </div>
//                               <ErrorMessage
//                                 name="volumeTotalizer"
//                                 component={TextError}
//                               />
//                             </div>
//                           </Col>

//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="LabelNew mb-1">Job No *</label>
//                               <div className="example-wrapper">
//                                 <ToolTip
//                                   content="Enter Job No"
//                                   direction="bottom"
//                                 >
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     // name="jobNo"
//                                     placeholder="Enter Job No."
//                                     autoComplete="off"
//                                     value={jobNo}
//                                     // onChange={(e) => setJobNo(e.target.value)}
//                                     onChange={(e) => {
//                                       const value = e.target.value;
//                                       if (/^\d*$/.test(value)) {
//                                         setJobNo(value);
//                                       }
//                                     }}
//                                   />
//                                 </ToolTip>
//                               </div>
//                               <ErrorMessage name="jobNo" component={TextError} />
//                             </div>
//                           </Col>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="LabelNew mb-1">
//                                 {" "}
//                                 Field Job Date *{" "}
//                               </label>
//                               <br />
//                               <div className="example-wrapper">
//                                 <ToolTip content="Select Date" direction="bottom">
//                                   <DatePicker
//                                     showIcon
//                                     closeOnScroll={true}
//                                     selected={startDate}
//                                     onChange={(date) => setStartDate(date)}
//                                     className="form-control"
//                                     dateFormat="dd-MMM-yyyy"
//                                     placeholderText="Select Date"
//                                   />
//                                 </ToolTip>
//                               </div>
//                               {/* <ErrorMessage name="fieldIssueDate" component={TextError} /> */}
//                             </div>
//                           </Col>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="LabelNew mb-1">
//                                 {" "}
//                                 Field Job Time *{" "}
//                               </label>
//                               <br />
//                               <div className="time-wrapper">
//                                 <div className="allTime">
//                                   <input
//                                     type="time"
//                                     onChange={handleTimeChange}
//                                     className="form-control"
//                                     step="1"
//                                   />
//                                 </div>
//                                 <div className="addTime">
//                                   <div className="example-wrapper">
//                                     <ToolTip
//                                       content="Please Select Time "
//                                       direction="bottom"
//                                     >
//                                       <Field
//                                         className="form-control"
//                                         name="fieldIssueTime"
//                                         placeholder="Please Select Time"
//                                         value={displayFormattedTime}
//                                         readOnly
//                                       />
//                                     </ToolTip>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </Col>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="Label mb-1">
//                                 {" "}
//                                 Service Engineer Name
//                               </label>
//                               <Field
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Service Engineer Name"
//                                 readOnly
//                                 value={serviceEngineerNm}
//                               />
//                             </div>
//                           </Col>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="Label mb-1">
//                                 {" "}
//                                 Service Engineer Mobile No
//                               </label>
//                               <Field
//                                 type="text"
//                                 maxLength="10"
//                                 className="form-control"
//                                 name="serviceEngineerMobNo"
//                                 value={userMblNo}
//                                 placeholder="Mobile No."
//                                 readOnly
//                               />
//                             </div>
//                           </Col>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="Label mb-1"> Site Type</label>
//                               <Field
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Select Site Type"
//                                 readOnly
//                                 value={siteType}
//                               />
//                             </div>
//                           </Col>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="Label mb-1"> Site Name</label>
//                               <Field
//                                 type="text"
//                                 className="form-control"
//                                 name="siteName"
//                                 placeholder="Site Name"
//                                 readOnly
//                                 value={siteNm}
//                               />
//                             </div>
//                           </Col>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="Label mb-1"> Customer Name</label>
//                               <Field
//                                 type="text"
//                                 className="form-control"
//                                 placeholder="Customer Name"
//                                 readOnly
//                                 value={customerNm}
//                               />
//                             </div>
//                           </Col>
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="Label mb-1">
//                                 {" "}
//                                 Customer Mobile No *{" "}
//                               </label>
//                               <Field
//                                 type="text"
//                                 maxLength="10"
//                                 name="customerMobileNo"
//                                 value={customerMblNo}
//                                 className="form-control"
//                                 placeholder="Customer Mobile No"
//                                 readOnly
//                               />
//                             </div>
//                           </Col>
//                           {!(siteType === "COCO") && (
//                             <Col md={6} className="mb-3">
//                               <div className="form-group">
//                                 <label className="Label mb-1">Dealer Name</label>
//                                 <Field
//                                   type="text"
//                                   className="form-control"
//                                   placeholder="Dealer Name"
//                                   value={dealerNm}
//                                   readOnly
//                                 />
//                               </div>
//                             </Col>
//                           )}
//                           {!(siteType === "COCO") && (
//                             <Col md={6} className="mb-3">
//                               <div className="form-group">
//                                 <label className="Label mb-1">
//                                   {" "}
//                                   Dealer Mobile No{" "}
//                                 </label>
//                                 <Field
//                                   type="text"
//                                   maxLength="10"
//                                   id="dealerMobileNo"
//                                   name="dealerMobileNo"
//                                   value={dealerMblNo}
//                                   className="form-control"
//                                   placeholder="Dealer Mobile No"
//                                   readOnly
//                                 />
//                               </div>
//                             </Col>
//                           )}
//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="LabelNew mb-1">
//                                 {" "}
//                                 Site Location Update *{" "}
//                               </label>
//                               <div className="example-wrapper">
//                                 <ToolTip
//                                   content="Enter Site location"
//                                   direction="bottom"
//                                 >
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     // name="siteAddress"
//                                     placeholder="Enter Site Location"
//                                     autoComplete="off"
//                                     value={siteAddress}
//                                     onChange={(e) => setSiteAddress(e.target.value)}
//                                   />
//                                 </ToolTip>
//                               </div>
//                               <ErrorMessage
//                                 name="siteAddress"
//                                 component={TextError}
//                               />
//                             </div>
//                           </Col>


//                           <Col md={6} className="mb-3">
//                             <div className="form-group">
//                               <label className="LabelNew mb-1">
//                                 Description *
//                               </label>
//                               <div className="example-wrapper">
//                                 <ToolTip
//                                   content="Enter Suitable Description"
//                                   direction="bottom"
//                                 >
//                                   <Field
//                                     as="textarea"
//                                     rows="3"
//                                     maxLength={100}
//                                     className="form-control"
//                                     // name="desc"
//                                     value={Desc}
//                                     placeholder="Enter Description"
//                                     autoComplete="off"
//                                     onChange={(e) => setDesc(e.target.value)}
//                                   />
//                                 </ToolTip>
//                               </div>
//                               <ErrorMessage name="desc" component={TextError} />
//                             </div>
//                           </Col>
//                           <div className="form-group mt-1">

//                             <button
//                               type="button"
//                               className="btn btn-info mb-3 flex-grow-1"
//                               onClick={HandleSendOtpFieldjob}
//                               disabled={!isgetotpButtonEnabled || !isOtpdisable || !isGetOtpButtonEnabled}
//                             >
//                               {loadingbutton ? (
//                                 <span className="ms-2">Please wait..</span>
//                               ) : (
//                                 buttonText
//                               )}

//                             </button>

//                           </div>

//                         </>
//                       )}
//                       {isOtpEnabled && (
//                         <>
//                           <Col md={6} className="mt-2">
//                             <div className="form-group">
//                               <label className="LabelNew mb-1">
//                                 {" "}
//                                 Upload Dispenser Photo *{" "}
//                               </label>
//                               <div className="example-wrapper">
//                                 <ToolTip
//                                   content="Upload dispenser photo"
//                                   direction="bottom"
//                                 >
//                                   <input
//                                     type="file"
//                                     className="form-control"
//                                     name="uploadDispenserPhoto"
//                                     placeholder="Upload Dispenser Photo"
//                                     accept=".jpg, .jpeg, .png"
//                                     onChange={(e) => {
//                                       formik.setFieldValue(
//                                         "uploadDispenserPhoto",
//                                         e.currentTarget.files[0]
//                                       );
//                                       SetfiledDispenserphoto('')
//                                       uploadImg(e);
//                                     }}
//                                   />
//                                 </ToolTip>
//                               </div>
//                               {/* <ErrorMessage
//                               name="uploadDispenserPhoto"
//                               component={TextError}
//                             /> */}
//                               {filedDispenserphoto && <p className="text-danger">{filedDispenserphoto}</p>}
//                             </div>
//                           </Col>
//                           <Col md={6} className="mt-2 mb-3">
//                             <div className="form-group">
//                               <label className="LabelNew mb-1">
//                                 {" "}
//                                 Field Engineer Remark *{" "}
//                               </label>
//                               <div className="example-wrapper">
//                                 <ToolTip
//                                   content="Enter Remark"
//                                   direction="bottom"
//                                 >
//                                   <Field
//                                     as="textarea"
//                                     className="form-control "
//                                     rows="3"
//                                     placeholder="Remark"
//                                     name="remark"
//                                   />
//                                 </ToolTip>
//                               </div>
//                               <ErrorMessage name="remark" component={TextError} />
//                             </div>
//                           </Col>
//                           <Col >
//                             <button
//                               type="submit"
//                               className="btn btn-primary mb-5"
//                               disabled={!isfieldjobButtonEnabled || iscalibrationstartcloseEnables || isButtonDisabled}
//                             >
//                               Submit Field Job{" "}
//                             </button>
//                           </Col>
//                         </>
//                       )}
//                     </Row>

//                     {/* old Note commented bcz of new changes made in this form */}
//                     {/* <h5 className="note">
//                       Note :- Please scan the device and get the data from
//                       dispenser.
//                     </h5> */}

//                     {/* ---------------------------------------------------------------- dispenser data
//         ---------------------------------------------------------------- */}
//                     {!(oprationType === "Rate Change" || oprationType === "Time Change" || oprationType === "Date Change") && (
//                       <div className="main-form">
//                         {/* //{show && Hide*/}
//                         {show ? (
//                           <Form>
//                             <hr />
//                             <Row>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Model Name
//                                   </label>
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     value={processData.modelName}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                             </Row>
//                             <hr />
//                             <h5 style={{ textAlign: "left", color: "#004417" }}>
//                               Motherboard (MCU)
//                             </h5>
//                             <Row>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Firmware Version No{" "}
//                                   </label>
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     value={processData.mcuBoardSoftwareSrNo}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Hardware Version{" "}
//                                   </label>
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     value={processData.mcuBoardHardwareVersion}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Board Serial No{" "}
//                                   </label>
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     value={processData.mcuBoardSrNo}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">SHA2</label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.mcuBoardSHA2}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Sign X-509-64 Bit Block{" "}
//                                   </label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.mcuBoardSignXBitBlock}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Board Public Key{" "}
//                                   </label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.mcuBoardPublicKey}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Board Private Key{" "}
//                                   </label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.mcuBoardPrivateKey}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     RCA Public Key{" "}
//                                   </label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.mcuBoardRCAPublicKey}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                             </Row>
//                             <hr />
//                             <h5 style={{ textAlign: "left", color: "#004417" }}>
//                               Totalizer (TOT)
//                             </h5>
//                             <Row>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Firmware Version No{" "}
//                                   </label>
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     value={processData.memBoard1SoftwareSrNo}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Hardware Version{" "}
//                                   </label>
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     value={processData.memBoard1HardwareVersion}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Board Serial No{" "}
//                                   </label>
//                                   <Field
//                                     type="text"
//                                     className="form-control"
//                                     value={processData.memBoard1BoardSrNo}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">SHA2</label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.memBoard1BoardSHA2}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Sign X-509-64 Bit Block{" "}
//                                   </label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.memBoard1SignXBitBlock}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Board Public Key{" "}
//                                   </label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.memBoard1PublicKey}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     Board Private Key{" "}
//                                   </label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.memBoard1PrivateKey}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                               <Col md={4} className="mb-3">
//                                 <div className="form-group">
//                                   <label className="Label mb-1">
//                                     {" "}
//                                     RCA Public Key{" "}
//                                   </label>
//                                   <Field
//                                     type="password"
//                                     className="form-control"
//                                     value={processData.memBoard1RCAPublicKey}
//                                     readOnly
//                                   />
//                                 </div>
//                               </Col>
//                             </Row>
//                             {csd.map((obj, key) => (
//                               <div key={key}>
//                                 <hr />
//                                 <h5
//                                   style={{
//                                     textAlign: "left",
//                                     color: "#004417",
//                                   }}
//                                 >
//                                   Customer Display (CSD-{key + 1})
//                                 </h5>
//                                 <Row>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Firmware Version No{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `csd${key + 1}BoardSoftwareSrNo`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Hardware Version{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `csd${key + 1}BoardHardwareVersion`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Serial No{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[`csd${key + 1}BoardSrNo`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">SHA2</label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[`csd${key + 1}BoardSHA2`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Sign X-509-64 Bit Block
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `csd${key + 1}BoardSignXBitBlock`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Public Key
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `csd${key + 1}BoardPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Private Key
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `csd${key + 1}BoardPrivateKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         RCA Public Key
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `csd${key + 1}BoardPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </div>
//                             ))}
//                             {mre.map((obj, key) => (
//                               <div key={key}>
//                                 <hr />
//                                 <h5
//                                   style={{
//                                     textAlign: "left",
//                                     color: "#004417",
//                                   }}
//                                 >
//                                   Pulser (MRE-{key + 1})
//                                 </h5>
//                                 <Row>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Firmware Version No
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `mre${key + 1}BoardSoftwareSrNo`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Hardware Version
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `mre${key + 1}BoardHardwareVersion`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Serial No
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[`mre${key + 1}BoardSrNo`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">SHA2</label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[`mre${key + 1}BoardSHA2`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Sign X-509-64 Bit Block
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `mre${key + 1}BoardSignXBitBlock`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Public Key
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `mre${key + 1}BoardRCAPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Private Key
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `mre${key + 1}BoardPrivateKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         RCA Public Key
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `mre${key + 1}BoardRCAPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </div>
//                             ))}
//                             {lkd.map((obj, key) => (
//                               <div key={key}>
//                                 <hr />
//                                 <h5
//                                   style={{
//                                     textAlign: "left",
//                                     color: "#004417",
//                                   }}
//                                 >
//                                   Operator Keypad Display (LKD-{key + 1})
//                                 </h5>
//                                 <Row>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Firmware Version No
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `lkd${key + 1}BoardSoftwareSrNo`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Hardware Version
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `lkd${key + 1}BoardHardwareVersion`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Serial No
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[`lkd${key + 1}BoardSrNo`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">SHA2</label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[`lkd${key + 1}BoardSHA2`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Sign X-509-64 Bit Block
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `lkd${key + 1}BoardSignXBitBlock`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Public Key
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `lkd${key + 1}BoardPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Private Key{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `lkd${key + 1}BoardPrivateKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         RCA Public Key{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `lkd${key + 1}BoardRCAPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </div>
//                             ))}
//                             {/* ---------------------------------------------------------------- Vapor Recovery (VR) */}
//                             {pvr.map((obj, key) => (
//                               <div key={key}>
//                                 <hr />
//                                 <h5
//                                   style={{
//                                     textAlign: "left",
//                                     color: "darkblue",
//                                   }}
//                                 >
//                                   Vapor Recovery (VR-{key + 1})
//                                 </h5>
//                                 <Row>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Firmware Version No{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `pvr${key + 1}BoardSoftwareSrNo`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Hardware Version{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `pvr${key + 1}BoardHardwareVersion`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Serial No{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[`pvr${key + 1}BoardSrNo`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">SHA2</label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[`pvr${key + 1}BoardSHA2`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Sign X-509-64 Bit Block{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `pvr${key + 1}BoardSignXBitBlock`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Public Key{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `pvr${key + 1}BoardPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Private Key{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `pvr${key + 1}BoardPrivateKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         RCA Public Key{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `pvr${key + 1}BoardRCAPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </div>
//                             ))}
//                             {/* ---------------------------------------------------------------- Printer (Printer) */}
//                             {prn.map((obj, key) => (
//                               <div key={key}>
//                                 <hr />
//                                 <h5
//                                   style={{
//                                     textAlign: "left",
//                                     color: "darkblue",
//                                   }}
//                                 >
//                                   Printer (Printer-{key + 1})
//                                 </h5>
//                                 <Row>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Firmware Version No{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `prn${key + 1}BoardSoftwareSrNo`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Hardware Version{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `prn${key + 1}BoardHardwareVersion`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Serial No{" "}
//                                       </label>
//                                       <Field
//                                         type="text"
//                                         className="form-control"
//                                         value={
//                                           processData[`prn${key + 1}BoardSrNo`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">SHA2</label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[`prn${key + 1}BoardSHA2`]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Sign X-509-64 Bit Block{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `prn${key + 1}BoardSignXBitBlock`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Public Key{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `prn${key + 1}BoardPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         Board Private Key{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `prn${key + 1}BoardPrivateKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                   <Col md={4} className="mb-3">
//                                     <div className="form-group">
//                                       <label className="Label mb-1">
//                                         {" "}
//                                         RCA Public Key{" "}
//                                       </label>
//                                       <Field
//                                         type="password"
//                                         className="form-control"
//                                         value={
//                                           processData[
//                                           `prn${key + 1}BoardRCAPublicKey`
//                                           ]
//                                         }
//                                         readOnly
//                                       />
//                                     </div>
//                                   </Col>
//                                 </Row>
//                               </div>
//                             ))}
//                           </Form>
//                         ) : (
//                           <></>
//                         )}
//                       </div>
//                     )}
//                   </Form>
//                 </>
//                 {/* ) : (
//                   <NotScanned />
//                 )} */}
//               </Card.Body>
//             </Card>
//           </>
//         );
//       }}
//     </Formik>
//   );
// };





